import { z } from 'zod';
export const chatSearchSchema = z.object({
  sessionId: z.uuid().optional().catch(undefined),
  offset: z.coerce.number().int().nonnegative().catch(0),
});
export const chatSearchDefaults = { offset: 0 };
